module.exports = __webpack_public_path__ + "2b9fc575.png";